import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import Vorlagen from "./pages/Vorlagen";
import VorlageForm from "./pages/VorlageForm";
import VorlageDetail from "./pages/VorlageDetail";
import MeineMitzeichnungen from "./pages/MeineMitzeichnungen";
import Kalender from "./pages/Kalender";
import Webhooks from "./pages/Webhooks";
import Amtsperioden from "./pages/Amtsperioden";
import BuergerportalEinstellungen from "./pages/BuergerportalEinstellungen";
import ApiSchluessel from "./pages/ApiSchluessel";
import BuergerPortal from "./pages/BuergerPortal";
import BuergerPortalSitzung from "./pages/BuergerPortalSitzung";
import BuergerPortalVorlage from "./pages/BuergerPortalVorlage";
import BuergerPortalGate from "./components/BuergerPortalGate";
import GremienDashboard from "./pages/GremienDashboard";
import SitzungenList from "./pages/SitzungenList";
import SitzungDetail from "./pages/SitzungDetail";
import SitzungForm from "./pages/SitzungForm";
import Einstellungen from './pages/Einstellungen';
import Benutzer from './pages/Benutzer';
import MeinKonto from './pages/MeinKonto';
import SsoEinstellungen from './pages/SsoEinstellungen';
import ProjektorSteuerung from './pages/ProjektorSteuerung';
import ProjektorAnsicht1 from './pages/ProjektorAnsicht1';
import ProjektorAnsicht2 from './pages/ProjektorAnsicht2';
import ProjektorAnsicht3 from './pages/ProjektorAnsicht3';
import ProjektorAnsicht4 from './pages/ProjektorAnsicht4';
import ProjektorAnsicht5 from './pages/ProjektorAnsicht5';
import Login from './pages/Login';
import Gremien from "./pages/Gremien";
import Mitglieder from "./pages/Mitglieder";
import Beschluesse from "./pages/Beschluesse";

import { PermissionProvider } from "./permissions/PermissionContext";
import GremiumBerechtigungenPage from "./admin/GremiumBerechtigungenPage";
function AppShell() {
  const { ready, authenticated, user, authMode } = useAuth();

  if (!ready || authMode === null) {
    return <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f5f5f5" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>🚒</div>
        <div style={{ color: "#999", fontSize: 14 }}>Wird geladen…</div>
      </div>
    </div>;
  }

  if (!ready) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center",
                    height: "100vh", background: "#111", color: "#fff", flexDirection: "column", gap: 16 }}>
        <div style={{ fontSize: 36 }}>🔒</div>
        <div style={{ fontFamily: "IBM Plex Sans, sans-serif", fontSize: 14, color: "#888" }}>
          Authentifizierung läuft…
        </div>
      </div>
    );
  }

  if (!authenticated) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/protokoll-genehmigen" element={<div style={{padding:40,textAlign:"center"}}>Weiterleitung...</div>} />
            <Route path="/projektor/:id/ansicht/1" element={<ProjektorAnsicht1 />} />
            <Route path="/projektor/:id/ansicht/2" element={<ProjektorAnsicht2 />} />
        <Route path="/projektor/:id/ansicht/3" element={<ProjektorAnsicht3 />} />
        <Route path="/projektor/:id/ansicht/4" element={<ProjektorAnsicht4 />} />
        <Route path="/projektor/:id/ansicht/5" element={<ProjektorAnsicht5 />} />
            <Route path="/buerger" element={<BuergerPortalGate><BuergerPortal /></BuergerPortalGate>} />
            <Route path="/buerger/sitzungen/:id" element={<BuergerPortalGate><BuergerPortalSitzung /></BuergerPortalGate>} />
            <Route path="/buerger/vorlagen/:id" element={<BuergerPortalGate><BuergerPortalVorlage /></BuergerPortalGate>} />
            <Route path="/login" element={<Login onLogin={(data) => { window.location.href = "/"; }} />} />
          <Route path="*" element={<Login onLogin={(data) => { window.location.href = "/"; }} />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <PermissionProvider><BrowserRouter>
      {/* Projektor-Routen ohne Layout/Sidebar (Vollbild fuer Beamer) */}
      <Routes>
        <Route path="/projektor/:id/ansicht/1" element={<ProjektorAnsicht1 />} />
        <Route path="/projektor/:id/ansicht/2" element={<ProjektorAnsicht2 />} />
        <Route path="/projektor/:id/ansicht/3" element={<ProjektorAnsicht3 />} />
        <Route path="/projektor/:id/ansicht/4" element={<ProjektorAnsicht4 />} />
        <Route path="/projektor/:id/ansicht/5" element={<ProjektorAnsicht5 />} />
        <Route path="*" element={
          <div className="layout">
            <Sidebar user={user} />
        <main className="main">
          <Routes>
            <Route path="/protokoll-genehmigen" element={<div style={{padding:40,textAlign:"center"}}>Weiterleitung...</div>} />
            <Route path="/login" element={<Login onLogin={(data) => { window.location.href = "/"; }} />} />
            <Route path="/buerger" element={<BuergerPortalGate><BuergerPortal /></BuergerPortalGate>} />
            <Route path="/buerger/sitzungen/:id" element={<BuergerPortalGate><BuergerPortalSitzung /></BuergerPortalGate>} />
            <Route path="/buerger/vorlagen/:id" element={<BuergerPortalGate><BuergerPortalVorlage /></BuergerPortalGate>} />
            <Route path="/mein-dashboard" element={<GremienDashboard />} />
            <Route path="/vorlagen" element={<Vorlagen />} />
            <Route path="/vorlagen/neu" element={<VorlageForm />} />
            <Route path="/vorlagen/:id" element={<VorlageDetail />} />
            <Route path="/vorlagen/:id/bearbeiten" element={<VorlageForm />} />
            <Route path="/meine-mitzeichnungen" element={<MeineMitzeichnungen />} />
            <Route path="/webhooks" element={user?.isAdmin ? <Webhooks /> : <div style={{padding:40}}>Keine Berechtigung.</div>} />
            <Route path="/amtsperioden" element={user?.isAdmin ? <Amtsperioden /> : <div style={{padding:40}}>Keine Berechtigung.</div>} />
            <Route path="/buergerportal-einstellungen" element={user?.isAdmin ? <BuergerportalEinstellungen /> : <div style={{padding:40}}>Keine Berechtigung.</div>} />
            <Route path="/api-schluessel" element={user?.isAdmin ? <ApiSchluessel /> : <div style={{padding:40}}>Keine Berechtigung.</div>} />
            <Route path="/" element={<Dashboard />} />
            <Route path="/sitzungen" element={<SitzungenList />} />
            <Route path="/sitzungen/neu" element={<SitzungForm />} />
            <Route path="/kalender" element={<Kalender />} />
            <Route path="/sitzungen/:id" element={<SitzungDetail />} />
            <Route path="/sitzungen/:id/bearbeiten" element={<SitzungForm />} />
            <Route path="/gremien" element={user?.isAdmin ? <Gremien /> : <div style={{padding:40}}>Keine Berechtigung.</div>} />
            <Route path="/mitglieder" element={user?.isAdmin ? <Mitglieder /> : <div style={{padding:40}}>Keine Berechtigung.</div>} />
            <Route path="/beschluesse" element={<Beschluesse />} />
            <Route path="/einstellungen" element={user?.isAdmin ? <Einstellungen /> : <div style={{padding:40}}>Keine Berechtigung.</div>} />
            <Route path="/projektor/:id/steuerung" element={<ProjektorSteuerung />} />
            <Route path="/benutzer" element={user?.isAdmin ? <Benutzer /> : <div style={{padding:40}}>Keine Berechtigung.</div>} />
            <Route path="/mein-konto" element={<MeinKonto />} />
            <Route path="/einstellungen/sso" element={user?.isAdmin ? <SsoEinstellungen /> : <div style={{padding:40}}>Keine Berechtigung.</div>} />
          </Routes>
        </main>
          </div>
        } />
                  <Route path="/admin/berechtigungen" element={<GremiumBerechtigungenPage />} />
          </Routes>
    </BrowserRouter></PermissionProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppShell />
    </AuthProvider>
  );
}
